"use client";

import { c as _c } from "react/compiler-runtime";
import { IconSearch, IconX } from "@tabler/icons-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
interface Props {
  value: string;
  onChange: (next: string) => void;
  onSubmit: () => void;
  autoFocus?: boolean;
}
export function SearchInputBar(t0) {
  const $ = _c(16);
  const {
    value,
    onChange,
    onSubmit,
    autoFocus
  } = t0;
  const showClear = value.length > 0;
  let t1;
  if ($[0] !== onSubmit) {
    t1 = event => {
      event.preventDefault();
      onSubmit();
    };
    $[0] = onSubmit;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IconSearch className="pointer-events-none absolute left-3 size-5 text-muted-foreground" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onChange) {
    t3 = event_0 => onChange(event_0.target.value);
    $[3] = onChange;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== autoFocus || $[6] !== t3 || $[7] !== value) {
    t4 = <Input type="text" role="searchbox" aria-label="Search products" autoFocus={autoFocus} placeholder="Search for stickers, labels, materials..." value={value} onChange={t3} className="h-12 rounded-md border-input pl-10 pr-10 text-base" />;
    $[5] = autoFocus;
    $[6] = t3;
    $[7] = value;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== onChange || $[10] !== showClear) {
    t5 = showClear && <Button type="button" variant="ghost" size="icon" aria-label="Clear search" className="absolute right-1 size-8" onClick={() => onChange("")}><IconX className="size-4" /></Button>;
    $[9] = onChange;
    $[10] = showClear;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t1 || $[13] !== t4 || $[14] !== t5) {
    t6 = <form role="search" aria-label="Search products" className="relative flex items-center" onSubmit={t1}>{t2}{t4}{t5}</form>;
    $[12] = t1;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}